export const getCategoryByRoute = ({ categories, route }) => {
  return categories.find((category) => category.route === route);
};

export const getCategoryById = (categories, id) => {
  return categories.find((category) => category.id === id);
};

export default null;
